import { DefaultState } from '@src/redux/types'

import {
  SD_FEEDBACK_EVALUATION_BY_EVALUATOR,
  SD_FEEDBACK_EVALUATION_BY_SUBJECT,
  SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT,
  SD_FEEDBACK_EVALUATION_CREATE,
  SD_FEEDBACK_EVALUATION_EVALUATE_INFO,
  SD_FEEDBACK_EVALUATION_STATS,
  SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED,
  SD_FEEDBACK_QUESTION_ALL,
  SD_FEEDBACK_RESPONSE_ALL,
  SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL,
  SD_FEEDBACK_STAFF_ASSIGN_CREATE,
  SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST,
  SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST,
  SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [SD_FEEDBACK_EVALUATION_BY_EVALUATOR]: DefaultState<`${typeof API.SD_FEEDBACK_EVALUATION_BY_EVALUATOR}`, 'get'>
  [SD_FEEDBACK_EVALUATION_BY_SUBJECT]: DefaultState<`${typeof API.SD_FEEDBACK_EVALUATION_BY_SUBJECT}`, 'get'>
  [SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT]: DefaultState<
    `${typeof API.SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT}`,
    'get'
  >
  [SD_FEEDBACK_EVALUATION_CREATE]: DefaultState<`${typeof API.SD_FEEDBACK_EVALUATION}`, 'post'>
  [SD_FEEDBACK_RESPONSE_ALL]: DefaultState<`${typeof API.SD_FEEDBACK_RESPONSE_ALL}`, 'get'>

  [SD_FEEDBACK_STAFF_ASSIGN_CREATE]: DefaultState<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN}`, 'post'>
  [SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST]: DefaultState<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL}`, 'get'>
  [SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST]: DefaultState<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN_STAFF}`, 'get'>
  [SD_FEEDBACK_EVALUATION_EVALUATE_INFO]: DefaultState<`${typeof API.SD_FEEDBACK_EVALUATION_EVALUATE_INFO}`, 'get'>
  [SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED]: DefaultState<
    `${typeof API.SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED}`,
    'get'
  >
  [SD_FEEDBACK_EVALUATION_STATS]: DefaultState<`${typeof API.SD_FEEDBACK_EVALUATION_STATS}`, 'get'>
  [SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL]: DefaultState<
    `${typeof API.SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL}`,
    'get'
  >
  [SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL]: DefaultState<`${typeof API.SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL}`, 'get'>
  [SD_FEEDBACK_QUESTION_ALL]: DefaultState<`${typeof API.SD_FEEDBACK_QUESTION_ALL}`, 'get'>
} = () => ({
  [SD_FEEDBACK_EVALUATION_BY_EVALUATOR]: defaultState(),
  [SD_FEEDBACK_EVALUATION_BY_SUBJECT]: defaultState(),
  [SD_FEEDBACK_EVALUATION_EVALUATE_INFO]: defaultState(),
  [SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED]: defaultState(),
  [SD_FEEDBACK_EVALUATION_STATS]: defaultState(),
  [SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT]: defaultState(),
  [SD_FEEDBACK_EVALUATION_CREATE]: defaultState(),
  [SD_FEEDBACK_RESPONSE_ALL]: defaultState(),
  [SD_FEEDBACK_STAFF_ASSIGN_CREATE]: defaultState(),
  [SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST]: defaultState(),
  [SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST]: defaultState(),
  [SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL]: defaultState(),
  [SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL]: defaultState(),
  [SD_FEEDBACK_QUESTION_ALL]: defaultState(),
})
